
export const CREATE_ADDRESS_REQUEST = "CREATE_ADDRESS_REQUEST";
export const CREATE_ADDRESS_FAILURE = "CREATE_ADDRESS_FAILURE";
export const CREATE_ADDRESS_SUCCESS = "CREATE_ADDRESS_SUCCESS";

export const UPDATE_ADDRESS_REQUEST = "UPDATE_ADDRESS_REQUEST";
export const UPDATE_ADDRESS_FAILURE = "UPDATE_ADDRESS_FAILURE";
export const UPDATE_ADDRESS_SUCCESS = "UPDATE_ADDRESS_SUCCESS";

export const UPDATE_BILLING_ADDRESS_REQUEST = "UPDATE_BILLING_ADDRESS_REQUEST";
export const UPDATE_BILLING_ADDRESS_FAILURE = "UPDATE_BILLING_ADDRESS_FAILURE";
export const UPDATE_BILLING_ADDRESS_SUCCESS = "UPDATE_BILLING_ADDRESS_SUCCESS";

export const DELETE_ADDRESS_REQUEST = "DELETE_ADDRESS_REQUEST";
export const DELETE_ADDRESS_FAILURE = "DELETE_ADDRESS_FAILURE";
export const DELETE_ADDRESS_SUCCESS = "DELETE_ADDRESS_SUCCESS";

export const GET_ADDRESS_REQUEST = "GET_ADDRESS_REQUEST";
export const GET_ADDRESS_FAILURE = "GET_ADDRESS_FAILURE";
export const GET_ADDRESS_SUCCESS = "GET_ADDRESS_SUCCESS";

export const GET_VALIDATE_ADDRESS_REQUEST = "GET_VALIDATE_ADDRESS_REQUEST";
export const GET_VALIDATE_ADDRESS_FAILURE = "GET_VALIDATE_ADDRESS_FAILURE";
export const GET_VALIDATE_ADDRESS_SUCCESS = "GET_VALIDATE_ADDRESS_SUCCESS";

export const GET_ACTIVE_ADDRESS_REQUEST='GET_ACTIVE_ADDRESS_REQUEST';
export const GET_ACTIVE_ADDRESS_SUCCESS='GET_ACTIVE_ADDRESS_SUCCESS';
export const GET_ACTIVE_ADDRESS_FAILURE='GET_ACTIVE_ADDRESS_FAILURE';